import { ITransportConfig } from 'app/components/data/DataSource/interfaces'
import { escapeRegExp, isObjAndNotNull, ObjectParser } from 'app/components/data/utils'

export class HttpService {

  private variables: object = {}

  fetchJSON<U>(transportConfig: ITransportConfig, urlParams?: object): Promise<U> {
    const url = this.constructUrl(transportConfig, urlParams)
    return fetch(url, transportConfig.request)
      .then((response) => {
        return response.text()
      })
      .then((text) => {
        text = text.replace(/u0026/g, '&')
        text = text.replace(/\\/g, "")
        return JSON.parse(text)
      })
      .then((json) => json)
      .then((json) => {
        let records: U

        let modifiedJson = json
        if ('body' in json) {
          modifiedJson = JSON.parse(json.body.replace(/\\/g, ""))
        }

        this.insertIntoVariables(modifiedJson, transportConfig)

        if (transportConfig.dataPathExpression) {
          records = ObjectParser.QueryAndGetFirst<U>(modifiedJson, transportConfig.dataPathExpression)
        } else {
          records = modifiedJson
        }

        return records
      })
  }

  insertIntoVariables(json: any, transportConfig: ITransportConfig): void {
    const canInsert = isObjAndNotNull(transportConfig.variables) && isObjAndNotNull(json)

    if (canInsert) {
      Object.keys(transportConfig.variables).forEach((key) => {
        const index = transportConfig.variables[key]
        this.variables[key] = ObjectParser.QueryAndGetFirst(json, index)
      })
    }

    return json
  }

  insertObjIntoVariables(obj: object): void {
    Object.keys(obj).forEach((key) => {
      this.variables[key] = obj[key]
    })
  }

  protected constructUrl(transportConfig: ITransportConfig, urlParams?: object): string {
    const configRequest = transportConfig.request
    const hasParams = isObjAndNotNull(configRequest) && isObjAndNotNull(configRequest.params)
    const hasUrlParams = isObjAndNotNull(urlParams)
    let url = transportConfig.url

    if (hasUrlParams) {
      Object.keys(urlParams).forEach((key) => {
        const paramRegex = new RegExp(`\\:${key}`, 'g')
        url = url.replace(paramRegex, urlParams[key])
      })
    }

    if (hasParams) {
      Object.keys(configRequest.params).forEach((paramKey, index) => {
        const paramValue = this.replaceStrWithVariables(configRequest.params[paramKey])

        url += index === 0 ? '?' : '&'
        url += `${paramKey}=${paramValue}`
      })
    }

    return url
  }

  protected replaceStrWithVariables(str: string) {
    Object.keys(this.variables).forEach((key) => {
      const escapedKey = escapeRegExp(key)
      const keyRegex = new RegExp(`(${escapedKey})`, 'g')
      const replacement = this.variables[key]

      str = str.replace(keyRegex, replacement)
    })

    return str
  }
}



// WEBPACK FOOTER //
// ./src/app/components/data/DataSource/Remote/HttpService/index.ts